export const SPIN_URL_SESSION_STORAGE_NAME = 'locationSpinPage';

export const EMAIL_USER_SPIN_SESSION_STORAGE_NAME='userSpinLoginEmail';

export const COUPON_CODE_SESSION_STORAGE_NAME = 'spinAndWinCouponSelected';
